module.exports = __webpack_public_path__ + "static/media/chevron_off.671d0882.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chevron_off.svg
// module id = 371
// module chunks = 0